import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import FAQSection from './components/FAQSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <FAQSection />
        <CommentsSection />
        <ContactSection />
        <FeaturesSection />
        <MediaSection />
        <CardsSection />
        <TopicsSection />
        <RankingSection />
        <CarouselSection />
        <IndexSection />
        <UpdatesSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}